import { Fragment } from 'react';
import face from '~/assets/icons/face.svg';
import { Text } from '~/components/ui/Text';
import { useLayoutSelector } from '../../redux';
import { headTitle } from './Head.model';
import {
	StyledContainer,
	StyledDivider,
	StyledHeading,
	StyledStepText,
} from './Head.styled';

const Head: React.FC = () => {
	const tabIndex = useLayoutSelector(
		(state) => state.characterCreation.tabIndex,
	);
	const maxTabIndex = useLayoutSelector(
		(state) => state.characterCreation.maxTabIndex,
	);

	return (
		<Fragment>
			<StyledContainer>
				<StyledHeading>
					<img src={face} />
					<Text>
						Создание
						<br />
						персонажа
					</Text>
				</StyledHeading>
				<StyledStepText>
					{headTitle[tabIndex]} {tabIndex + 1} <span>/ {maxTabIndex + 1}</span>
				</StyledStepText>
			</StyledContainer>
			<StyledDivider />
		</Fragment>
	);
};

export { Head };
